<template>
	<div id="navigation" class="screen title-screens">
		<div class="screen-container">
			<GeneralHeader />
			<main v-bind:class="{ 'active' : isActive }">
				<div id="nav-choices">
					<div id="nav-choices-title">
						<img id="venetoclax-hdr"  width="565" src="../assets/navigation/venetoclax.png" />
					</div>
					<div id="nav-choices-main">
						<div id="nav-choices-aml">
							<div class="nav-choice-hdr">
								<img id="heading-aml"  width="120" height="54" src="../assets/navigation/heading-aml.png" />
							</div>
							<div class="button-choice">
								<router-link v-bind:to="'/aml-cll/intro/pierce'">
									<img id="button-patient-pierce"  width="369" src="../assets/navigation/button-a-patient-01-pierce.png" />
								</router-link>
							</div>
							<div class="button-choice">
								<router-link v-bind:to="'/aml-cll/intro/carson'">
									<img id="button-patient-carson"  width="369" src="../assets/navigation/button-a-patient-02-carson.png" />
								</router-link>
							</div>
							<div class="button-choice">
								<router-link v-bind:to="'/aml-cll/intro/neutropenia'">
									<img id="button-management-center"  width="369" src="../assets/navigation/button-a-misc-03-management.png" />
								</router-link>
							</div>
						</div>
						<div id="nav-choices-cll">
							<div class="nav-choice-hdr">
								<img id="heading-cll"  width="120" height="54" src="../assets/navigation/heading-cll.png" />
							</div>
							<div class="button-choice">
								<router-link v-bind:to="'/aml-cll/intro/bishop'">
									<img id="button-patient-bishop"  width="369" src="../assets/navigation/button-b-patient-01-bishop.png" />
								</router-link>
							</div>
							<div class="button-choice">
								<router-link v-bind:to="'/aml-cll/intro/gordon'">
									<img id="button-patient-gordon"  width="369" src="../assets/navigation/button-b-patient-02-gordon.png" />
								</router-link>
							</div>
							<div class="button-choice">
								<router-link v-bind:to="'/aml-cll/intro/calendars'">
									<img id="button-calendars"  width="369" src="../assets/navigation/button-b-misc-03-calendars.png" />
								</router-link>
							</div>
						</div>
					</div>
					<div id="nav-choice-footer">
						<a target="_blank" href="https://www.rxabbvie.com/pdf/venclexta.pdf"><img id="footer-copy"  width="828" src="../assets/navigation/footer-copy.png" /></a>
					</div>
				</div>
			</main>
			<GeneralFooter/>
		</div>
	</div>
</template>
<script>
import GeneralHeader from '@/components/GeneralHeader'
import GeneralFooter from '@/components/GeneralFooter'
export default {
	components: {
		GeneralHeader,
		GeneralFooter
	},
	data() {
		return {
			isActive: false
		}
	},
	created(){
		var this_ = this
		setTimeout(function(){ 
			this_.isActive = true
		},120)
	}
}
</script>
<style scoped>
main {
	opacity: 0;
	transition: all 333ms ease-in-out;
}

	main.active {
		opacity: 1;
	}

#nav-choices {
	background: url(../assets/navigation/nav-choices-background.png) no-repeat;
	background-size: cover;
	margin: 0 auto;
	transform: translateX(2px);
	width: 930px;
	height: 597px;
}

	#nav-choices-title {
		height: 78px;
	}

		#venetoclax-hdr {
			display: block;
			margin: 32px auto 0;
			text-align: center;
		}

#nav-choices-main {
	justify-content: space-between;
	padding: 0 53px 0 48px;
}

	#nav-choices-main > div {
		align-items: center;
		display: flex;
		flex-direction: column;
		width: 412px;
	}

		.nav-choice-hdr {
			margin-bottom: 12px;
		}

		.button-choice {
			margin-bottom: 10px;
		}

#nav-choice-footer {
	padding: 13px 0 0 50px;
}
</style>
